import { useState } from "react";
import { Loader2 } from "lucide-react";
import { errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const field = "w-full rounded-2xl border border-fg/10 bg-[var(--ink)] px-5 py-4 text-fg outline-none placeholder:text-mist focus:border-[var(--volt)]/60";

export const AuthForm = ({ onDone }) => {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = mode === "login" ? await login(f.email, f.password) : await register(f.name, f.email, f.phone, f.password);
      onDone?.(u);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="auth-form" className="w-full max-w-md rounded-[2rem] border border-fg/10 bg-[var(--ink-2)] p-8">
      <div className="flex gap-1 rounded-full bg-[var(--ink)] p-1">
        {[["login", "Accedi"], ["register", "Registrati"]].map(([m, l]) => (
          <button type="button" key={m} onClick={() => { setMode(m); setError(""); }} data-testid={`auth-tab-${m}`}
            className={`flex-1 rounded-full py-2.5 text-sm transition-colors ${mode === m ? "bg-[var(--paper)] text-[var(--ink)]" : "text-fg2"}`}>{l}</button>
        ))}
      </div>
      <div className="mt-6 space-y-3">
        {mode === "register" && <input required minLength={2} value={f.name} onChange={set("name")} placeholder="Nome e cognome" data-testid="auth-name-input" className={field} />}
        <input required type="email" value={f.email} onChange={set("email")} placeholder="Email" data-testid="auth-email-input" className={field} />
        {mode === "register" && <input required type="tel" inputMode="tel" pattern="\+?[0-9 ]{8,20}" title="Inserisci un numero di cellulare valido (es. +39 333 1234567)" value={f.phone} onChange={set("phone")} placeholder="Cellulare (es. +39 333 1234567)" data-testid="auth-phone-input" className={field} />}
        <input required type="password" minLength={mode === "register" ? 8 : 1} value={f.password} onChange={set("password")}
          placeholder={mode === "register" ? "Password (min. 8 caratteri)" : "Password"} data-testid="auth-password-input" className={field} />
      </div>
      {error && <p className="mt-3 text-sm text-[var(--flare)]" data-testid="auth-error">{error}</p>}
      <button disabled={busy} data-testid="auth-submit-button" className="shine mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[var(--volt)] py-4 font-semibold text-[var(--ink)] disabled:opacity-60 active:scale-95">
        {busy && <Loader2 className="h-5 w-5 animate-spin" />} {mode === "login" ? "Accedi" : "Crea account"}
      </button>
    </form>
  );
};
